import WebSocketStore from 'core/classes/services/WebSocketStore'
import { TLNRChampionServer } from 'onboarding/components/widgets/public/forms/lnr/models'
import { IResponseErrorPayload } from 'onboarding/types/response'
import {
  throwOnErrorWithoutPayload,
  throwOnInvalidRequestParams,
} from 'onboarding/utils/errorResponse/throwOnApiError'

const CONTROLLER = 'lr-champion'

class LnrChampionApi {
  public async fetchOneByRequestId(requestId: number): Promise<TLNRChampionServer> {
    const ws = WebSocketStore.get('onboarding')
    const response = await ws.call<{
      item: TLNRChampionServer
      errorPayload?: IResponseErrorPayload
    }>({
      service: CONTROLLER,
      action: 'fetchOneByRequestId',
      payload: { requestId },
      withoutTokenRefresh: true,
      isAuth: true,
      returnError: true,
    })
    if (response.status !== 'success') {
      const fallbackMessage = 'Failed to fetch contact'
      throwOnInvalidRequestParams(response, fallbackMessage)
      throwOnErrorWithoutPayload(response, fallbackMessage)
    }

    return response.data.item
  }

  public async createOne(payload: TLRChampionCreatePayload): Promise<TLNRChampionServer> {
    const ws = WebSocketStore.get('onboarding')
    const response = await ws.call<{
      item: TLNRChampionServer
      errorPayload?: IResponseErrorPayload
    }>({
      service: CONTROLLER,
      action: 'create',
      payload,
      withoutTokenRefresh: true,
      isAuth: true,
      returnError: true,
    })
    if (response.status !== 'success') {
      const fallbackMessage = 'Failed to create contact'
      throwOnInvalidRequestParams(response, fallbackMessage)
      throwOnErrorWithoutPayload(response, fallbackMessage)
    }

    return response.data.item
  }

  public async updateOne(
    id: number,
    payload: TLRChampionUpdatePayload
  ): Promise<TLNRChampionServer> {
    const ws = WebSocketStore.get('onboarding')
    const response = await ws.call<{
      item: TLNRChampionServer
      errorPayload?: IResponseErrorPayload
    }>({
      service: CONTROLLER,
      action: 'update',
      payload: { id, payload },
      withoutTokenRefresh: true,
      isAuth: true,
      returnError: true,
    })
    if (response.status !== 'success') {
      const fallbackMessage = 'Failed to update contact'
      throwOnInvalidRequestParams(response, fallbackMessage)
      throwOnErrorWithoutPayload(response, fallbackMessage)
    }

    return response.data.item
  }
}

export const lnrChampionApi = new LnrChampionApi()

export type TLRChampionCreatePayload = {
  RequestId: number
  FirstName: string
  LastName: string
  Email: string
  JobTitle: string
  WorkPhone_Prefix: string
  WorkPhone: string
  MobilePhone_Prefix: string | null
  MobilePhone: string | null
}

export type TLRChampionUpdatePayload = {
  FirstName: string
  LastName: string
  Email: string
  JobTitle: string
  WorkPhone_Prefix: string
  WorkPhone: string
  MobilePhone_Prefix: string | null
  MobilePhone: string | null
}
